module.exports = __webpack_public_path__ + "img/enquiries.7c003068.svg";